export function formatRupiah(value) {
    const cleanValue = Math.floor(parseFloat(value));
  
    if (!cleanValue) return "Rp. 0";
  
    const numberString = cleanValue
      .toString()
      .replace(/[^,\d]/g, "")
      .toString();
    let rest = numberString.length % 3;
    let rupiah = numberString.substr(0, rest);
    const thousand = numberString.substr(rest).match(/\d{3}/gi);
  
    if (thousand) {
      const separator = rest ? "." : "";
      rupiah += separator + thousand.join(".");
    }
  
    return "Rp. " + rupiah;
}

export function formatPersen(value) {
  if (value === null || value === undefined || value === '') return '0';
  return String(value).replace('.', ',');
}


// WEBPACK FOOTER //
// ./src/helpers/format.js